import { Component, OnInit, Input } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FactorAnalysis } from 'src/app/models/analysis/factor-analysis.model';
import { PeerAnalysis } from "../../../models/analysis/peer-analysis.model";

import { TableUtil } from "src/app/utils";

@Component({
  selector: 'app-analytics-factor-analysis',
  templateUrl: './analytics-factor-analysis.component.html',
  styleUrls: ['./analytics-factor-analysis.component.scss']
})
export class AnalyticsFactorAnalysisComponent implements OnInit {

  @Input() currentFA: FactorAnalysis;
  @Input() currentOriginalPA: PeerAnalysis;
  @Input() currentInvestablePA: PeerAnalysis;
  @Input() currentProtectedPA: PeerAnalysis;
  @Input() styleBoxData: any;

  @Input() inceptionDate: Date;
  @Input() lastDate: Date;

  selectedPage: string = 'styleBox';
  selectedTabTab: string = 'Exposure';
  selectedTab: string = 'deconcentration';
  selectedType: string;
  selectedIndex: number;

  constructor() { }

  ngOnInit(): void {
  }

  onTabChangeTab(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Exposure':      this.selectedTabTab='Exposure'; break;
      case 'Sensitivity':   this.selectedTabTab='Sensitivity'; break;
      case 'Stability':     this.selectedTabTab='Stability'; break;
      case 'Contributions': this.selectedTabTab='Contributions'; break;
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTab = ['deconcentration', 'diversification'][event.index];
  }

  onSelectedPeerChange(event) {
    this.selectedType = event.type;
    this.selectedIndex = event.index ? event.index : this.selectedIndex;
  }

  exportTable(){
    TableUtil.exportToExcel("tableToExport");
  }

}
